import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchOrders } from "../../redux/ordersSlice";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaInfoCircle,
  FaFileInvoice,
} from "react-icons/fa";
import SkeletonRow from "../../components/designLayouts/skeletons/rowSkeleton";
import { useNavigate } from "react-router-dom";
import formatPrice from "../../utils/formatPrice";

const OrderHistory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { items: orders, status } = useSelector((state) => state.orders);
  const precision = sessionStorage.getItem("prec");
  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchOrders());
    }
  }, [status, dispatch]);

  if (status === "loading") {
    return (
      <div className="min-h-screen bg-gray-100 px-4">
        <div className=" mx-auto bg-white shadow-md rounded-lg p-6">
          <h1 className="text-xl font-semibold text-gray-800 mb-4">Order #</h1>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-200 text-base">
              <thead>
                <tr className="bg-gray-200 text-gray-600 text-sm uppercase">
                  <th className="py-3 px-4 text-left whitespace-nowrap">
                    Order ID
                  </th>
                  <th className="py-3 px-4 text-left whitespace-nowrap">
                    Date
                  </th>
                  <th className="py-3 px-4 text-left whitespace-nowrap">
                    Status
                  </th>
                  <th className="py-3 px-4 text-right whitespace-nowrap">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {[...Array(5)].map((_, i) => (
                  <SkeletonRow key={i} />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  if (status === "failed") throw new Error("Could not fetch order history");

  return (
    <div className="min-h-screen py-10 bg-gray-100 p-6">
      <div className=" mx-auto bg-white shadow-md rounded-lg p-6">
        <h1 className="text-xl font-semibold text-gray-800 mb-4">
          Order History
        </h1>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-200">
            <thead>
              <tr className="bg-gray-200 text-gray-600 text-sm uppercase">
                <th className="py-3 px-4 text-left whitespace-nowrap">
                  Order ID
                </th>
                <th className="py-3 px-4 text-center  whitespace-nowrap">
                  Date
                </th>
                <th className="py-3 px-4 text-center whitespace-nowrap">
                  Status
                </th>
                <th className="py-3 px-4 text-right whitespace-nowrap">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr
                  key={order?.orderid}
                  className={`border-b ${index % 2 === 0 ? "bg-gray-50" : "bg-white"} hover:bg-gray-300 text-sm cursor-pointer`}
                  onClick={() => navigate(`/orders/${order?.orderid}`)}
                >
                  <td className="h-[10px] py-1 px-4 whitespace-nowrap">
                    {order?.doc_num}
                  </td>
                  <td className="h-[10px] py-1 px-4 whitespace-nowrap text-center">
                    {order?.date}
                  </td>
                  <td className="h-[10px] py-1 px-4 whitespace-nowrap">
                    <span
                      className={`flex w-24 mx-auto items-center gap-1 px-3 py-1 rounded-full text-xs justify-center font-medium ${
                        order?.order_status === "Delivered"
                          ? "bg-green-100 text-green-700"
                          : order?.order_status === "Pending" ||
                              order?.order_status === "To Invoice"
                            ? "bg-yellow-100 text-yellow-700"
                            : "bg-red-100 text-red-700"
                      }`}
                    >
                      {order?.order_status === "Delivered" && <FaCheckCircle />}
                      {order?.order_status === "Pending" && <FaInfoCircle />}
                      {order?.order_status === "Closed" && <FaTimesCircle />}
                      {order?.order_status === "To Invoice" && (
                        <FaFileInvoice />
                      )}
                      {order?.order_status}
                    </span>
                  </td>
                  <td className="h-[10px] py-1 px-4 whitespace-nowrap text-right">
                    {formatPrice(Number(order?.total).toFixed(precision))}{" "}
                    <span className="font-medium">{order?.symbol}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OrderHistory;
